import { Credential } from '../models/credential';
import { requests } from './agent';

const Auth = {
	authenticate: (credential: Credential) =>
		requests.post<string>('api/authenticationToken/', credential),
};

export default Auth;
